export class AppUtils {
  static emptyString(value: string): boolean {
    return (
      value === undefined || value === null || value === '' || value.toString().trim().length === 0
    );
  }
}
